module.exports = __webpack_public_path__ + "static/img/user-propile.c0ef2f69.svg";